import { validateNumber } from '@SHARED/js/helpers/misc';
import template from './InputNumberComponent.html';

export default {
  template,

  name: 'InputNumber',

  props: ['value'],

  methods: {
    increment() {
      this.$emit('input', validateNumber(this.value + 1));
    },

    decrement() {
      this.$emit('input', validateNumber(this.value - 1));
    },

    blur() {
      this.$emit('input', validateNumber(this.value));
    },

    selectAll: (event) => {
      // Workaround for Safari bug
      setTimeout(() => {
        event.target.select();
      }, 0);
    },
  },
};
